interface CurrencyInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  min?: string;
  className?: string;
  required?: boolean;
}

/** Number input for dollar amounts, with a fixed `$` prefix so it reads like currency while
 * still editing as a plain number (native `step`/`min` validation, no thousands separators). */
export function CurrencyInput({ value, onChange, placeholder, min = '0', className = '', required }: CurrencyInputProps) {
  return (
    <div className={`relative ${className}`}>
      <span className="pointer-events-none absolute left-2.5 top-1/2 -translate-y-1/2 text-sm text-gray-400">$</span>
      <input
        type="number"
        min={min}
        step="0.01"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        className="w-full rounded-md border border-gray-300 py-1.5 pl-5 pr-3 text-sm"
      />
    </div>
  );
}
